import { render, staticRenderFns } from "./app-order-pps-view.vue?vue&type=template&id=3a70cbae"
import script from "./app-order-pps-view.vue?vue&type=script&lang=ts"
export * from "./app-order-pps-view.vue?vue&type=script&lang=ts"
import style0 from "./app-order-pps-view.vue?vue&type=style&index=0&id=3a70cbae&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a70cbae')) {
      api.createRecord('3a70cbae', component.options)
    } else {
      api.reload('3a70cbae', component.options)
    }
    module.hot.accept("./app-order-pps-view.vue?vue&type=template&id=3a70cbae", function () {
      api.rerender('3a70cbae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-order-pps-view/app-order-pps-view.vue"
export default component.exports